import { Badge, BadgeColor } from "@/components/catalyst/badge";
import { ProDriverAgreementStatus } from "@/gql/graphql";

const statusConfig: Record<
  ProDriverAgreementStatus,
  { label: string; color: BadgeColor }
> = {
  [ProDriverAgreementStatus.Draft]: { label: "Draft", color: "zinc" },
  [ProDriverAgreementStatus.Sent]: { label: "Sent", color: "yellow" },
  [ProDriverAgreementStatus.Viewed]: { label: "Viewed", color: "blue" },
  [ProDriverAgreementStatus.Signed]: { label: "Signed", color: "green" },
  [ProDriverAgreementStatus.Declined]: { label: "Declined", color: "red" },
  [ProDriverAgreementStatus.Voided]: { label: "Voided", color: "orange" },
};

export function AgreementStatusBadge({
  status,
}: {
  status: ProDriverAgreementStatus;
}) {
  const { label, color } = statusConfig[status];

  return (
    <Badge className="py-0" color={color}>
      {label}
    </Badge>
  );
}
